// extracted by mini-css-extract-plugin
export default {"root":"_1Uuxn","stepList":"_16QCT","instruction":"_1BZQb"};